import { Box, Text } from '@rbilabs/universal-components';

import Picture from 'components/picture';
import { primitive } from 'styles/constants/primitives';

export const MOBILE_SAFETY_MEASURE = '100px';
export const PRODUCT_IMAGE_HEIGHT_MOBILE = '300px';
export const PRODUCT_IMAGE_HEIGHT_DESKTOP = '350px';

export const ProductOverviewContainer = Box.withConfig<{ withSpacing: boolean }>(p => ({
  width: 'full',
  background: primitive.$white,
  paddingBottom: p.withSpacing
    ? {
        base: 3,
        md: 8,
      }
    : 0,
}));

export const ProductImageContainer = Box.withConfig({
  flex: 1,
  background: primitive.$white,
  alignItems: 'center',
});

export const ProductImage = Picture.withConfig({
  width: 'full',
  height: { base: PRODUCT_IMAGE_HEIGHT_MOBILE, md: PRODUCT_IMAGE_HEIGHT_DESKTOP },
  minHeight: { base: MOBILE_SAFETY_MEASURE, md: 0 },
  objectFitContain: true,
});

export const ProductInformationContainer = Box.withConfig({
  background: primitive.$white,
  width: 'full',
  paddingX: 4,
  alignItems: 'center',
  alignSelf: 'center',
});

export const ProductTitle = Text.withConfig({
  variant: 'headerTwo',
  margin: 0,
  fontSize: '2xl',
  lineHeight: 'md',
  paddingY: '12px',
  paddingX: '$8',
  textAlign: 'center',
});
